import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "../styles/vitrina.css"; // Estilos del componente

import producto1 from "../assets/dist/img/producto1.png";
import producto2 from "../assets/dist/img/producto2.png";
import producto3 from "../assets/dist/img/producto3.png";
import producto4 from "../assets/dist/img/producto4.png";
import producto5 from "../assets/dist/img/producto5.png";

const ProductosVitrina = () => {
  // Array de productos definido aquí mismo
  const productos = [
    {
      nombre: "Café Tostado de Temporada 500gr",
      imagen: producto1,
      precio: "55.000",
      descripcion:
        "Granos seleccionados de la cosecha más reciente, con aroma y sabor únicos según la temporada.",
    },
    {
      nombre: "Molino Electrónico Importado",
      imagen: producto2,
      precio: "95.000",
      descripcion:
        "Molido uniforme y rápido para preparar café de especialidad en casa.",
    },
    {
      nombre: "Vaso Metálico para Café",
      imagen: producto3,
      precio: "35.000",
      descripcion:
        "Vaso térmico de acero inoxidable, mantiene tu café caliente por horas.",
    },
    {
      nombre: "Kit Degustación de Cafés",
      imagen: producto4,
      precio: "60.000",
      descripcion:
        "Pequeñas muestras (125gr) de cafés de origen para explorar distintos aromas y sabores.",
    },
    {
      nombre: "Aceite de Café",
      imagen: producto5,
      precio: "25.000",
      descripcion:
        "Aceite esencial de café con aroma rico y duradero, ideal para velas aromáticas, decoración del hogar, difusores, humidificadores y artículos del hogar",
    },
  ];

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        {productos.map((producto, index) => (
          <Col key={index} xs={12} sm={6} md={4} lg={3} className="mb-4">
            <Card className="producto-card text-center shadow-sm">
              <Card.Img
                variant="top"
                src={producto.imagen}
                alt={producto.nombre}
                className="producto-img"
              />
              <Card.Body>
                <Card.Title>{producto.nombre}</Card.Title>
                {producto.descripcion && (
                  <Card.Text className="producto-desc">
                    {producto.descripcion}
                  </Card.Text>
                )}
                <Card.Text className="producto-precio">
                  ${producto.precio}
                </Card.Text>
                <a
                  href="https://wa.me/573214230046?text=Hola%20quiero%20comprar%20este%20producto"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-add-cart"
                >
                  Pedir por WhatsApp
                </a>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default ProductosVitrina;
